<template>
	<!-- 门店票券管理－门店票券分类管理 -->
	<div>
		<content-view v-show="$utils.renderWhen(this,'shopTicketCategory')">
			<div slot="header">
                <a-form :form="formSearch" layout="inline" class="vip-form">
					<a-form-item label="分类所在组">
						<a-select v-decorator="['groupId']" placeholder="请选择" allowClear @select="getTicketCategory">
							<a-select-option v-for="item in ticketCategoryGroupList" :key="item.id" :value="item.id">{{item.name}}</a-select-option>
						</a-select>
					</a-form-item>
					<a-form-item class="wrap-header-button">
						<a-button @click="getTicketCategory" type="primary">筛选</a-button>
						<a-button @click="handleResetGroup">重置</a-button>
					</a-form-item>
                </a-form>
            </div>
		<a-spin v-if="shopId && shopId != -1" :spinning="spinning">
			<div class="shop-ticket-category-manage">
				<div>
					<div class="shop-ticket-category-title flex flex-space-between mb8">
						<span class="font-bigger text-color-65">票券分类</span>
						<span class="font-biggest text-color-65">
							<a-icon v-if="getBtnByAuth('addTicketInCategory')" @click="openCategory()" class="cursor-pointer" type="plus-circle" />
							<a-icon v-if="getBtnByAuth('orderByTicketInCategory')" @click="activeSort = !activeSort" class="cursor-pointer ml8" :class="activeSort ? 'text-primary' : ''" type="sort-ascending" />
						</span>
					</div>
					<ul class="category-list">
						<li
						v-for="(item,index) in ticketCategoryList"
						@click="activeItem(item.id, item.name, index, item.isPreinstall)"
						:class="'category-item' + (item.isCurrent ? ' category-item-current' : '')" 
						:key="item.id"
						>
							<div class="category-item-icon">
								<a-icon type="reconciliation" />
							</div>
							<div class="category-item-info">
								<div class="flex flex-space-between">
									<a-tooltip placement="top" :title="item.name">
										<span class="category-item-info-name text-color-65">{{item.name}}</span>
									</a-tooltip>
									<span class="category-item-info-count text-color-45">{{item.goodsCount || 0}}张</span>
								</div>
								<div class="group-name">{{item.groupName}}</div>
								<div>
									<span v-if="getBtnByAuth('editTicketInCategory') && !item.isPreinstall">
										<a v-if="!item.isEnable" @click.stop="openCategory(item.id, item.name, item.groupName)" class="text-primary mr16">编辑</a>
										<span @click.stop v-else class="text-disabled mr16">编辑</span>
									</span>
									<a-popconfirm v-if="getBtnByAuth('stateTicketInCategory')"
									@confirm="stateTicketCategory(item.id, item.isEnable, item.goodsCount)"
									>
										<template slot="title">
											<div v-if="!item.isEnable && item.goodsCount === 0">该分类下暂无票券，无法操作上架</div>
											<div v-if="!item.isEnable && item.goodsCount > 0">确定将该票券分类上架吗?</div>
											<div v-if="item.isEnable">下架后该分类及分类下的票</div>
											<div v-if="item.isEnable">券将不在收银台进行展示</div>
										</template>
										<a @click.stop class="text-primary mr16">{{['上架', '下架'][Number(item.isEnable)]}}</a>
									</a-popconfirm>
									<span v-if="getBtnByAuth('deleteTicketInCategory') && !item.isPreinstall">
										<a-popconfirm
										v-if="!item.isEnable"
										title="确定将该票券分类删除吗?"
										@confirm="deleteTicketCategory(item.id)"
										>
											<a @click.stop class="text-primary">删除</a>
										</a-popconfirm>
										<span @click.stop v-else class="text-disabled">删除</span>
									</span>
								</div>
								<div v-if="activeSort" class="category-item-sort-active">
									<a v-if="index" @click.stop="sortTicketCategory(item.id, 1)" class="text-primary mr16">上移</a>
									<span @click.stop v-else class="text-disabled mr16">上移</span>
									<span @click.stop v-if="index === (ticketCategoryList.length - 1)" class="text-disabled mr16">下移</span>
									<a v-else @click.stop="sortTicketCategory(item.id, -1)" class="text-primary mr16">下移</a>
									<a v-if="index" @click.stop="sortTicketCategory(item.id, 0)" class="text-primary">移至首位</a>
									<span @click.stop v-else class="text-disabled mr16">移至首位</span>
								</div>
							</div>
						</li>
					</ul>
				</div>
				<div>
					<div class="shop-ticket-category-title flex flex-space-between mb8">
						<span class="font-bigger text-color-65">{{currentName}}</span>
						<a-button v-if="getBtnByAuth('addTicketIn') && !isPreinstall" @click="openTicket" type="primary">新增分类门店票券</a-button>
					</div>
					<div class="mt8 mr16 mb8 ml16 table-box" ref="tableBox">
						<a-table
						bordered
						:columns="columns"
						:dataSource="dataSource"
						:pagination="false"
						:scroll="{y: heightY, x: 800}"
						:rowKey="record => record.ticketTemplateId"
						>
							<span slot="isOnShelves" slot-scope="key">{{['已下架', '上架中'][Number(key)]}}</span>
							<span slot="ticketType" slot-scope="key">{{key | ticketType}}</span>
							<template slot="actions" slot-scope="a, row, index">
								<router-link v-if="getBtnByAuth('detailStoreTicket')" class="text-primary" :to="{ name: 'categoryTicketDetail', params: {ticketTemplateId: row.ticketTemplateId} }">详情</router-link>
									<a-popconfirm
										v-if="getBtnByAuth('deleteTicketIn') && !isPreinstall"
										title="确定将该票券从该票券分类中移除吗?"
										@confirm="removeTicketInCategory(row.ticketTemplateId)"
										>
										<a-divider type="vertical"></a-divider>
										<a class="text-primary">移除</a>
									</a-popconfirm>
									<span v-if="getBtnByAuth('orderByTicketIn')">
										<a-divider type="vertical"></a-divider>
										<a v-if="index" class="text-primary" @click="sortTicketInCategory(row.ticketTemplateId, 1)">上移</a>
										<span v-else class="text-disabled">上移</span>
										<a-divider type="vertical"></a-divider>
										<span v-if="index === (dataSource.length - 1)" class="text-disabled">下移</span>
										<a v-else class="text-primary" @click="sortTicketInCategory(row.ticketTemplateId, -1)">下移</a>
										<a-divider type="vertical"></a-divider>
										<a v-if="index" class="text-primary" @click="sortTicketInCategory(row.ticketTemplateId, 0)">移至首位</a>
										<span v-else class="text-disabled">移至首位</span>
									</span>
								</template>
						</a-table>
					</div>
				</div>
			</div>
		</a-spin>
		<a-empty v-else>
			<span slot="description" class="font-big22">请切换到各门店查看</span>
		</a-empty>
		</content-view>
		<a-modal
		centered
		:title="titleTicketInCategory"
		:visible="visibleTicketInCategory"
		:confirmLoading="confirmLoading"
		@cancel="closeCategory"
		@ok="saveTicketCategory"
		>
			<a-form :form="formTicketInCategory" layout="inline">
				<a-form-item label="分 类 名 称 ">
					<a-input style="width: 350px" v-decorator="['name',{rules: [{required: true, max: 10, whitespace: true, message: '请输入分类名称(10字以内)'}]}]" placeholder="0/10"></a-input>
				</a-form-item>
				<a-form-item label="分类所在组" class="mt24">
					<a-select style="width: 350px" v-decorator="['groupId',{rules: [{required: true, message: '请选择分类分组'}]}]" placeholder="请选择">
						<a-select-option v-for="item in ticketCategoryGroupList" :key="item.id" :value="item.id">{{item.name}}</a-select-option>
					</a-select>
				</a-form-item>
			</a-form>
		</a-modal>
		<a-modal
		centered
		title="新增分类门店票券"
		:width="800"
		:visible="visibleTicket"
		:confirmLoading="confirmLoading"
		@cancel="closeTicket"
		@ok="saveClassTicket"
		>
			<a-form :form="formTicket" layout="inline" class="store-one-form">
				<a-form-item label="票券分类选择">
					<a-select v-decorator="['id',{rules: [{required: true}]}]" placeholder="请选择" style="width: 280px">
						<a-select-option :vlaue="item.id" v-for="item in ticketCategoryList.filter(e => !e.isPreinstall)" :key="item.id">{{item.name}}</a-select-option>
					</a-select>
				</a-form-item>
				<div class="mt8 mb8 pt8" style="border-top: 1px solid #bbb">票券选择</div>
				<a-form-item label="票券状态" class="mb24">
					<a-select allowClear v-decorator="['isOnShelves']" placeholder="请选择" style="width: 190px">
						<a-select-option :value="1">上架中</a-select-option>
						<a-select-option :value="0">已下架</a-select-option>
					</a-select>
				</a-form-item>
				<a-form-item label="票券内部标识">
					<a-input style="width: 200px" v-decorator="['name']" placeholder="请输入"></a-input>
				</a-form-item>
				<a-form-item>
					<a-button class="mr8" type="primary" @click="search">筛选</a-button>
					<a-button @click="handleReset">重置</a-button>
				</a-form-item>
			</a-form>
			<a-table
			bordered
			:columns="columns1"
			:dataSource="dataSource1"
			:row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
			:pagination="false"
			:scroll="{y: 380}"
			:rowKey="record => record.ticketTemplateId"
			:loading="getTicktListLoading"
			>
				<span slot="isOnShelves" slot-scope="key">{{['已下架', '上架中'][Number(key)]}}</span>
			</a-table>
		</a-modal>
		<router-view></router-view>
	</div>
</template>

<script type="text/javascript">
import { mapGetters } from "vuex";
const columns = [
	{
		title: '票券名称',
		dataIndex: 'showName',
		width: 150
	},
	{
		title: '票券内部标识',
		dataIndex: 'name',
		width: 150
	},
	{
		title: '票券状态',
		dataIndex: 'isOnShelves',
        scopedSlots: { customRender: "isOnShelves" },
		width: 90
	},
	{
		title: '类型',
		dataIndex: 'type',
        scopedSlots: { customRender: "ticketType" },
		width: 80
	},
	{
		title: '操作',
		dataIndex: 'id',
		scopedSlots: { customRender: 'actions' },
		width: 280
	},
];
const columns1 = [
	{
		title: '票券名称',
		dataIndex: 'showName',
		width: '40%'
	},
	{
		title: '票券内部标识',
		dataIndex: 'name',
		width: '40%'
	},
	{
		title: '票券状态',
        dataIndex: "isOnShelves",
        scopedSlots: { customRender: "isOnShelves" },
		width: '20%'
	}
]
export default {
	name: "shopTicketCategory",
	components: {},
	props: {},
	data() {
		return {
			columns,
			columns1,
			activeSort: false,
			dataSource: [],
			dataSource1: [],
			visibleTicketInCategory: false,
			titleTicketInCategory: '新增票券分类',
			nameTicketInCategory: '',
			selectedRowKeys: [],
			selectedRows: [],
			visibleTicket: false,
			ticketCategoryList: [],
			id: undefined,
			confirmLoading: false,
			currentId: '',
			currentName: '',
			currentIndex: 0,
			isPreinstall: undefined,
			heightY: '55vh',
			spinning: false,
			getTicktListLoading: false,
			ticketCategoryGroupList: []
		};
	},
	computed: {
		...mapGetters(["shopId"]),
	},
	methods: {
		handleResetGroup() {
			this.formSearch.resetFields();
			this.getTicketCategory();
		},
		openCategory(id = undefined, name = '', groupName='') {
			this.visibleTicketInCategory = true;
			if(id) {
				this.titleTicketInCategory = '编辑票券分类';
				this.id = id;
				this.$nextTick(() => {
					this.formTicketInCategory.setFieldsValue({'name': name, 'groupId': this.ticketCategoryGroupList.filter(item => item.name == groupName)[0].id})
				})
			}else {
				this.titleTicketInCategory = '新增票券分类';
				this.id = undefined;
			}
		},
		closeCategory() {
			this.visibleTicketInCategory = false;
			this.formTicketInCategory.resetFields();
		},
		handleReset () {
			this.formTicket.resetFields(['isOnShelves', 'name']);
			this.getList();
		},
		search() {
			this.getList();
		},
		onSelectChange(selectedRowKeys,selectedRows) {
			this.selectedRowKeys = selectedRowKeys;
			this.selectedRows = selectedRows;
		},
		openTicket() {
			this.visibleTicket = true;
			this.$nextTick(() => {
				this.formTicket.setFieldsValue({'id': this.currentId})
				this.getList();
			})
		},
		closeTicket() {
			this.visibleTicket = false;
			this.selectedRowKeys = [];
			this.selectedRows = [];
			this.formTicket.resetFields();
		},
		activeItem(id, currentName, currentIndex, isPreinstall) {
			this.ticketCategoryList.forEach(item => {
				item.isCurrent = false;
				if(item.id === id) {
					item.isCurrent = true;
					this.currentId = id;
					this.currentName = currentName;
					this.currentIndex = currentIndex;
					this.isPreinstall = isPreinstall;
					this.getTicketInCategory();
				}
			})
		},
		getList() {
			if(!this.shopId || this.shopId == -1) return
			this.formTicket.validateFields((errors, values) => {
				if (errors) {
					return false;
				}
				delete values.id;
				this.getTicktListLoading = true;
				this.$api.totalPlatform.getTotalTicketList({
					body:{
						...values,
						sellShopId: this.shopId,
					}
				}).then(res => {
					this.getTicktListLoading = false;
					this.dataSource1 = res;
				}).catch(err => {
					this.getTicktListLoading = false;
				})
			});
		},
		/**
		 * 分类操作
		 * 新增编辑保存分类
		 */
		saveTicketCategory() {
			this.formTicketInCategory.validateFields((err, values) => {
				if(!err) {
					this.confirmLoading = true;
					this.$api.shopTicket[this.id ? 'updateTicketCategory' : 'createTicketCategory']({
						body: {
							name: values.name,
							groupId: values.groupId,
							shopId: this.shopId,
							id: this.id
						}
					}).then(res => {
						this.confirmLoading = false;
						this.closeCategory();
						this.getTicketCategory();
						this.$message.success('操作成功');
					}).catch(err => {
						this.confirmLoading = false;
					})
				}
			})
		},
		/**
		 * 分类操作
		 * 获取分类分组
		 */
		findAllCategoryGroup() {
			this.$api.shopTicket.findAllCategoryGroup().then(res => {
				this.ticketCategoryGroupList = res;
			})
		},
		/**
		 * 分类操作
		 * 获取分类
		 */
		getTicketCategory() {
			if(!this.shopId || this.shopId == -1) return;
			this.$api.shopTicket.getTicketCategory({
				query: {
					shopId: this.shopId,
					groupId: this.formSearch.getFieldValue('groupId')
				}
			}).then(res => {
				this.ticketCategoryList = res;
				if(res && Array.isArray(res) && res.length > 0) {
					this.currentId = res[this.currentIndex].id;
					this.currentName = res[this.currentIndex].name;
					this.isPreinstall = res[this.currentIndex].isPreinstall;
					res[this.currentIndex].isCurrent = true;
					this.getTicketInCategory();
				}
			})
		},
		/**
		 * 分类操作
		 * 上下架
		 */
		stateTicketCategory(id, isEnable, goodsCount) {
			if(!isEnable && !goodsCount) {
				return false;
			}
			this.$api.shopTicket[isEnable ? 'downTicketCategory' : 'upTicketCategory']({
				params: {
					id: id
				}
			}).then(res => {
				this.getTicketCategory();
				this.$message.success('操作成功');
			})
		},
		/**
		 * 分类操作
		 * 删除
		 */
		deleteTicketCategory(id) {
			this.$api.shopTicket.deleteTicketCategory({
				params: {
					id: id,
				}
			}).then(res => {
				this.getTicketCategory();
				this.$message.success('操作成功');
			})
		},
		/**
		 * 分类操作
		 * 排序
		 * 0 置顶,1 上移一位，-1 下移一位"
		 */
		sortTicketCategory(id, type) {
			this.$api.shopTicket.sortTicketCategory({
				query: {
					id,
					type
				}
			}).then(res => {
				this.getTicketCategory();
				this.$message.success('操作成功');
			})
		},
		
		/**
		 * 分类下票券操作
		 * 获取分类票券顺序列表
		 */
		getTicketInCategory() {
			this.spinning = true;
			this.$api.shopTicket.getTicketInCategory({
				params: {
					counterCategoryId: this.currentId,
				}
			}).then(res => {
				this.spinning = false;
				this.dataSource = res;
				this.$nextTick(() => {
					this.heightY = this.$refs.tableBox.offsetHeight -43
				})
			}).catch(err => {
				this.spinning = false;
			})
		},
		/**
		 * 分类下票券操作
		 * 新增保存分类票券
		 */
		saveClassTicket() {
			if(this.selectedRows.length === 0) {
				this.$message.error('请选择票券');
				return false;
			}
			this.confirmLoading = true;
			let ticketList = this.selectedRows.map(item => {
				return ({
					counterCategoryId: this.formTicket.getFieldValue('id'),
					ticketTemplateId: item.ticketTemplateId
				});
			});
			this.$api.shopTicket.addTicketInCategory({
				body: ticketList
			}).then(res => {
				this.confirmLoading = false;
				this.closeTicket();
				this.getTicketCategory();
				this.$message.success('操作成功');
			}).catch(err => {
				this.confirmLoading = false
			})
		},
		/**
		 * 分类下票券操作
		 * 移除
		 */
		removeTicketInCategory(ticketTemplateId) {
			this.$api.shopTicket.removeTicketInCategory({
				query: {
					counterCategoryId: this.currentId,
					ticketTemplateId
				}
			}).then(res => {
				this.getTicketCategory();
				this.$message.success('操作成功');
			})
		},
		/**
		 * 分类下票券操作
		 * 排序
		 * 0 置顶,1 上移一位，-1 下移一位"
		 */
		sortTicketInCategory(ticketTemplateId, type) {
			this.$api.shopTicket.sortTicketInCategory({
				query: {
					counterCategoryId: this.currentId,
					ticketTemplateId,
					type
				}
			}).then(res => {
				this.getTicketInCategory();
				this.$message.success('操作成功');
			})
		},
	},
	beforeCreate() {
		this.form = this.$form.createForm(this);
		this.formTicketInCategory = this.$form.createForm(this);
		this.formTicket = this.$form.createForm(this);
		this.formSearch = this.$form.createForm(this);
	},
	created() {},
	mounted() {
		this.getTicketCategory();
		this.findAllCategoryGroup();
		window.onresize = () => {
			return (() => {
				this.heightY = this.$refs.tableBox.offsetHeight - 43
			})(
		)}
	},
	watch: {
		'$route'(val) {
			if(val.name === 'shopTicketCategory') {
				this.getTicketCategory();
			}
		},
		'shopId'() {
			this.getTicketCategory()
		},
		'heightY'(val) {
			this.heightY = val
		}
	}
};
</script>
<style lang="scss" scoped>
    .shop-ticket-category-manage {
		display: flex;
		overflow-x: scroll; 
		&>div {
			flex: 1;
			height: calc(100vh - 245px);
			background-color: #fff;
			.shop-ticket-category-title {
				height: 50px;
				padding: 10px 10px;
				border-bottom: 1px solid #e8e8e8;
				overflow: hidden;
				.anticon {
					&:hover {
						color: #FF6D33 !important;
					}
				}
			}
			.table-box {
				height: calc(100% - 70px);
			}
			&:first-child {
				min-width: 300px;
				max-width: 300px;
				margin-right: 16px;
				.category-list {
					margin: 0;
					width: 100%;
					height: calc(100% - 68px);
					overflow-x: hidden;
					overflow-y: scroll;
					&::-webkit-scrollbar {
						display: none;
					}
				}
			}
			.category-list {
				user-select: none;
				.category-item {
					display: flex;
					padding: 10px;
					height: 110px;
					overflow: hidden;
					cursor: pointer;
					&-current,
					&:hover {
						background: rgba(245,154,35,0.2);
					}
					>div {
						flex: 1;
					}
					&-icon {
						max-width: 60px;
						margin-right: 10px;
						margin-top: 15px;
						i {
							display: inline-block;
							padding-top: 16px;
							width: 100%;
							height: 60px;
							background-color: rgba(245,154,35,1);
							color: #fff;
							border-radius: 12px;
							font-size: 28px;
						}
					}
					&-info {
						&-name {
							display: inline-block;
							width: 141px;
							font-size: 16px;
                			white-space: nowrap;
							overflow: hidden;
							text-overflow: ellipsis;
						}
					}
					&-sort-active {
						margin-top: 4px;
					}
					.group-name {
						padding: 5px 0;
						font-size: 12px;
						color: rgba(0, 0, 0, .5);
					}
				}
			}
		}
	}
</style>
